export const images = [
    {
        id:1,
        imagePath: require('../img/image1.webp').default,
        alt: 'testing'
    },
    {
        id:2,
        imagePath: require('../img/image2.webp').default,
        alt: 'testing'
    },
    {
        id:3,
        imagePath: require('../img/image3.webp').default,
        alt: 'testing'
    },
    {
        id:4,
        imagePath: require('../img/inProgress.webp').default,
        alt: 'testing'
    }
]